import { Box, Typography } from "@mui/material";
import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Mousewheel, Keyboard } from "swiper";
// import { documentSteps } from "../../constants/constants";
import { nextCard, preCard, resetCard } from "../../redux/slices/CardSlices";
import { connect } from "react-redux";
import tick from "../../assets/icons/tick.png";
import { useTranslation } from "react-i18next";

const DocSteps = (props) => {
  const { tab, currentCard, custom, resetCard } = props;
  const { t } = useTranslation();

  const documentSteps = [
    {
      id: 1,
      name: t("doc-tab-1"),
      image: "/assets/icons/real-estate.png",
      multipleSteps: false,
    },
    {
      id: 2,
      name: t("hp-tab-1"),
      image: "/assets/icons/bank-balances.png",

      multipleSteps: false,
    },
    {
      id: 3,
      name: t("hp-tab-2"),
      image: "/assets/icons/securities.png",

      multipleSteps: false,
    },
    {
      id: 4,
      name: "",
      image: "/assets/icons/insurances.png",

      multipleSteps: false,
    },
    {
      id: 5,
      name: "",
      image: "/assets/icons/gold-raw-materials.png",

      multipleSteps: false,
    },
    {
      id: 6,
      name: "",
      image: "/assets/icons/share-holdings.png",

      multipleSteps: false,
    },
    {
      id: 7,
      name: "",
      image: "/assets/icons/co-share-holdings.png",

      multipleSteps: false,
    },

    {
      id: 8,
      name: t("doc-tab-2"),
      image: "",

      multipleSteps: false,
    },
    {
      id: 9,
      name: t("doc-tab-3"),
      image: "",

      multipleSteps: false,
    },
    {
      id: 10,
      name: t("doc-tab-4"),
      image: "",

      multipleSteps: false,
    },
  ];
  return (
    <>
      <Swiper
        cssMode={true}
        breakpoints={{
          // when window width is >= 320px
          280: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          // when window width is >= 640px

          640: {
            slidesPerView: 6,
            slidesPerGroup: 6,
          },
          // when window width is >= 900px
          900: {
            slidesPerView: 10,
            slidesPerGroup: 10,
          },
          1024: {
            slidesPerView: 12,
            slidesPerGroup: 12,
          },
        }}
        navigation={true}
        mousewheel={true}
        keyboard={true}
        modules={[Navigation, Mousewheel, Keyboard]}
        className="docSwiper"
      >
        <Box component="div" className="doc-steps" display="flex">
          {documentSteps.map((item, index, arr) => (
            <SwiperSlide
              className={`  "swiper-slide" ${
                tab === item.id && item.multipleSteps
                  ? "swiper-slide-with-arrow"
                  : "swiper-slide"
              }`}
              key={index}
            >
              <Box
                key={item.id}
                sx={{
                  position: "relative",
                  padding: "10px 0 0 0",
                }}
              >
                <Box
                  component="div"
                  display="flex"
                  sx={{
                    position: "absolute",
                    zIndex: "100000  !important ",
                    top: "-40%",
                    left: `${index !== arr.length - 1 ? "-40%" : "-120%"}`,
                    padding: "5px ",
                    width: `${index !== arr.length - 1 ? "90px" : "70px"}`,
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <Typography
                    variant="inherit"
                    fontSize="14px"
                    fontWeight="500"
                  >
                    {item.name}
                  </Typography>
                </Box>

                <Box
                  component="div"
                  marginTop={1}
                  display="flex"
                  alignItems="center"
                  paddingTop={1}
                >
                  {tab > item.id ? (
                    <Box
                      component="img"
                      src={tick}
                      width="15px"
                      sx={{
                        position: "absolute",
                        left: "2px",
                        top: "31px",
                        cursor: "pointer",
                        zIndex: 2000,
                      }}
                      onClick={() => {
                        props.nextCard();
                      }}
                    />
                  ) : null}
                  <Box
                    sx={{
                      color: tab === item.id ? "#444561" : "#957ba0",
                      backgroundColor:
                        tab >= item.id
                          ? "color.magentaLight2"
                          : "color.magentaMid2",
                      width: "21px",
                      height: "21px",
                      borderRadius: "50%",
                      zIndex: "1000",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      custom(index + 1);
                      resetCard();
                    }}
                  />
                  {index !== arr.length - 1 && (
                    <Box
                      component="div"
                      width="73px"
                      height="10px"
                      marginLeft="-2px"
                      sx={{ backgroundColor: "color.magentaMid2" }}
                    />
                  )}
                </Box>
              </Box>
            </SwiperSlide>
          ))}
        </Box>
      </Swiper>
    </>
  );
};

function mapStateToProps(state) {
  return {
    currentCard: state.currentCard.currentCard,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    nextCard: () => dispatch(nextCard()),
    preCard: () => dispatch(preCard()),
    resetCard: () => dispatch(resetCard()),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(DocSteps);
